import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { jsPDF } from "jspdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const SheEarnsDB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [certificateNumber, setCertificateNumber] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const downloadPDF = () => {
    if (!certificateData) return;

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Think5Whys SAKSHAM MSME Certificate", 20, 20);
    doc.setFontSize(12);

    const fields = [
      `Certificate Number: ${certificateData.certificateNumber}`,
      `Company Name: ${certificateData.companyName}`,
      `Owner Name: ${certificateData.ownerName}`,
      `Category: ${certificateData.category}`,
      `Udyam Number: ${certificateData.udyamNumber}`,
      `Registration Date: ${certificateData.registrationDate}`,
      `Valid Upto: ${certificateData.validity}`,
      `Status: ${certificateData.status}`,
      `Location: ${certificateData.location}`,
    ];

    fields.forEach((field, i) => doc.text(field, 20, 30 + i * 10));

    doc.save(`MSME_Certificate_${certificateData.certificateNumber}.pdf`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate length
    if (certificateNumber.length !== 16) {
      setIsError(true);
      setMessage("❌ Please enter a valid 16-character Certificate Number.");
      setCertificateData(null);
      return;
    }

    // Mock certificate data
    const mockCertificate = {
      certificateNumber,
      companyName: "InnovateTech Solutions Pvt. Ltd.",
      ownerName: "Sanjeev Kumar",
      registrationDate: "2023-04-25",
      validity: "2028-04-24",
      category: "Micro Enterprise",
      udyamNumber: "UDYAM-MH-12-0001234",
      location: "Palava City, Maharashtra, India",
      status: "Active",
    };

    setCertificateData(mockCertificate);
    setMessage("✅ Certificate Found in Think5Whys SAKSHAM Shakti Database.");
    setIsError(false);
  };

  return (
    <div className="mt-1">
      <section className="py-2 px-4 bg-black min-h-screen flex items-center">
        <div className="min-h-[70vh] bg-black border border-pink-500 p-8 rounded-2xl mx-auto w-full shadow-xl">
          <h3 className="text-lg lg:text-2xl font-bold text-yellow-200 mb-2 text-center">
            Think5Whys SAKSHAM Shakti Database
          </h3>
          <p className="mb-6 text-sm lg:text-m text-white text-center">
            Enter your 16-character Certificate Number
          </p>

          <form onSubmit={handleSubmit} className="flex justify-center mb-6">
            <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
              <input
                type="text"
                placeholder="Enter Certificate Number"
                value={certificateNumber}
                onChange={(e) => setCertificateNumber(e.target.value.toUpperCase())}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-center tracking-widest"
                maxLength={16}
                style={{width: "250px"}}
              />
              <button
                type="submit"
                className="w-full mt-4 sm:w-auto px-6 py-2 bg-pink-600 text-white rounded-lg hover:bg-teal-700 transition"
              >
                Search
              </button>
            </div>
          </form>

          {message && (
            <p
              className={`mt-2 text-center text-sm font-medium ${
                isError ? "text-red-600" : "text-green-600"
              }`}
            >
              {message}
            </p>
          )}

          {certificateData && !isError && (
            <div className="mt-2 bg-black text-white rounded-xl p-6 shadow-inner border border-gray-200">
              <h4 className="text-lg lg:text-xl font-semibold text-pink-500 mb-4 text-center">
                SAKSHAM Shakti Certificate Details
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
                <p className="text-white">
                  <strong>Certificate Number:</strong> {certificateData.certificateNumber}
                </p>
                <p className="text-white">
                  <strong>Company Name:</strong> {certificateData.companyName}
                </p>
                <p className="text-white">
                  <strong>Owner Name:</strong> {certificateData.ownerName}
                </p>
                <p className="text-white">
                  <strong>Category:</strong> {certificateData.category}
                </p>
                <p className="text-white">
                  <strong>Udyam No:</strong> {certificateData.udyamNumber}
                </p>
                <p className="text-white">
                  <strong>Registration Date:</strong> {certificateData.registrationDate}
                </p>
                <p className="text-white">
                  <strong>Valid Upto:</strong> {certificateData.validity}
                </p>
                <p className="text-white">
                  <strong>Status:</strong>{" "}
                  <span className="text-green-600 font-semibold">
                    {certificateData.status}
                  </span>
                </p>
                <p className="sm:col-span-2 text-white">
                  <strong>Location:</strong> {certificateData.location}
                </p>
              </div>
              <div className="mt-2 flex justify-center">
                <button
                  onClick={downloadPDF}
                  className="flex items-center gap-2 w-48 px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
                >
                  <FontAwesomeIcon icon={faDownload} /> Download PDF
                </button>
              </div>                
            </div>
          )}
        </div>
      </section>
      <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
          </div>
        </div>
      </footer>    
    </div>
  );
};

export default SheEarnsDB;
